/*eslint-disable*/
import { useState,useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

// import Navbar from "../../Componenets/Navbar";
import Business_eligible_img from "../../Assests/images/businees_eligiblr_center.png";
import check_icon_card from "../../Assests/images/CHECK_ICON.png";
import how_it_work_img from "../../Assests/images/how_work_image.png";
import fifaicon1 from "../../Assests/images/fifaIcon1.png";
import fifaicon2 from "../../Assests/images/fifaIcon2.png";
import fifaicon3 from "../../Assests/images/fifaIcon3.png";
import expertise_icon from "../../Assests/images/expertise_icon.png";
import speed_icon from "../../Assests/images/speed_icon.png";
import return_maxi from "../../Assests/images/return_icon.png";
import zero_upfront from "../../Assests/images/upfront_icon.png";
import counter_img1 from "../../Assests/images/couterimg1.png";
import counter_img2 from "../../Assests/images/counterimg2.png";
import counter_img3 from "../../Assests/images/counterimg3.png";
import counter_img4 from "../../Assests/images/counterimg4.png";
import testimonialiconcomma from "../../Assests/images/testimonialiconcomma.png";
import starIcon from "../../Assests/images/starticontestimonial.png";
import footer_logo from "../../Assests/images/footer_img.png";
import FifaSwiper from "../../Componenets/Swiperfifa";
import LeadCaptureModal from "../../Componenets/LeadCaptureModal";
import { useNavigate } from "react-router-dom";
const index = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
  AOS.init({
    duration: 800,   // animation duration
    easing: "ease-in-out",
    once: true,      // animation runs only once
  });
}, []);

  return (
    <div>
      <LeadCaptureModal showModal={showModal} setShowModal={setShowModal} />

      <section class="banner_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="banner_heading">
                <h1 data-aos="fade-up">
                  Don’t Leave Money <br />
                  <span>on the Table</span>
                </h1>
                <p data-aos="fade-right">Your Partner in Recovering FICA Tip Credits</p>
                <div className="d-flex flex-wrap gap-2" data-aos="fade-left">
                  <button
                    className="calculate_credit"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/Fica-Calculator")}
                    
                  >
                    Tip Credit Calculation
                  </button>
                  <button
                    className="calculate_credit2"
                    style={{ cursor: "pointer" }}
                   onClick={() => setShowModal(true)}

                    
                  >
                    Get Started
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="fifa_tip_credit">
        <div className="container">
          <div className="row align-items-center">
            <h1 className="tip_content_text" data-aos="fade-up">
              The <span>FICA Tip Credit</span> You're Missing Out On
            </h1>

            <div className="col-lg-4">
              <div className="tip-card"data-aos="fade-right">
                <div className="icon-circle">
                  <img src={fifaicon1} className="img-fluid iconfia" alt="" />
                </div>
                <h4>What Is It</h4>
                <p>
                  A dollar-for-dollar tax credit for employers who pay FICA
                  taxes on employee tips. This is NOT a deduction—it's a direct
                  reduction of your tax bill.
                </p>
                <button
                  class="fifa_button"
                  style={{ cursor: "pointer" }}
                 onClick={() => setShowModal(true)}

                >
                  Learn More
                </button>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="tip-card" data-aos="fade-up">
                <div className="icon-circle">
                  <img src={fifaicon3} className="img-fluid iconfia" alt="" />
                </div>
                <h4>How Much</h4>
                <p>
                  Up to 7.65% of qualified tip income. For a restaurant with 20
                  tipped employees, this can mean $20,000+ per year in
                  credits. Find out today!
                </p>
                <button
                  class="fifa_button"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    navigate("/Fica-Calculator");
                  }}
                >
                  Tip Credit Calculation
                </button>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="tip-card" data-aos="fade-left">
                <div className="icon-circle">
                  <img src={fifaicon2} className="img-fluid iconfia" alt="" />
                </div>
                <h4>Who Qualifies</h4>
                <p>
                  Restaurants, bars, hotels, and any hospitality business with
                  tipped employees. If your staff receives tips, you're likely
                  eligible.
                </p>
                <button
                  class="fifa_button"
                  style={{ cursor: "pointer" }}
                 onClick={() => setShowModal(true)}

                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="business_eligible">
        <div className="container">
          <div className="row justify-content-center">
            <div className="business_elig_content text-center">
              <h1 data-aos="fade-up">Is Your Business Eligible?</h1>
              <p className="ptext" data-aos="fade-down">
                Many hospitality businesses qualify for the FICA Tip Credit but
                don't realize it. See if your business type is eligible:
              </p>
              <div className="row image_section_eligi">
                <div className="col-lg-4 col-md-6 col-sm-12 position-relative">
                  <div className="card_content_busineligi" data-aos="fade-right">
                    <h5 className="fw-bold">Full-Service Restaurants</h5>
                    <p className="pcard_con">
                      Establishments where servers take orders and deliver food
                      to customers at tables, including fine dining, casual
                      dining, and family restaurants.
                    </p>
                    <h6>Examples:</h6>
                    <div className="flex flex-wrap">
                      <span>Steakhouses</span>
                    <span>Italian restaurants</span>
                    <span>Diners, etc</span>
                    </div>
                  </div>
                  <div className="card_content_busineligi" data-aos="fade-right">
                    <h5 className="fw-bold">Catering Companies</h5>
                    <p className="pcard_con">
                      Businesses that provide food service at remote sites where
                      staff receives tips from clients or guests.
                    </p>
                    <h6>Examples:</h6>
                    <div className="flex flex-wrap">
                    <span>Wedding caterers</span>
                    <span>Corporate event caterers, etc</span>
                    </div>
                  </div>
                  <div className="card_content_busineligi" data-aos="fade-right">
                    <h5 className="fw-bold">Hotels & Resorts</h5>
                    <p className="pcard_con">
                      Hospitality businesses where bellhops, room service staff,
                      concierge, and other employees receive tips.
                    </p>
                    <h6>Examples:</h6>
                    <div className="flex flex-wrap">
                    <span>Luxury hotels</span>
                    <span>Boutique hotels</span>
                    <span>Resorts, etc</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  nonee-col">
                  <img
                    src={Business_eligible_img}
                    className="business_imagr"
                    alt=""
                  />
                </div>
                <div className="col-lg-4 col-md-6  position-relative">
                  <div className="card_content_businelig" data-aos="fade-left">
                    <h5 className="fw-bold">Bars & Nightclubs</h5>
                    <p className="pcard_con">
                      Establishments primarily serving alcoholic beverages where
                      bartenders and servers receive tips from customers.
                    </p>
                    <h6>Examples:</h6>
                    <div className="flex flex-wrap">
                    <span>Sports bars</span>
                    <span>Cocktail lounges</span>
                    <span>Nightclubs, etc</span>
                    </div>
                  </div>
                  <div className="card_content_businelig" data-aos="fade-left">
                    <h5 className="fw-bold">Coffee Shops & Cafes</h5>
                    <p className="pcard_con">
                      Establishments serving beverages and light meals where
                      baristas and counter staff receive tips.
                    </p>
                    <h6>Examples:</h6>
                    <div className="flex flex-wrap">
                    <span>Coffee houses</span>
                    <span>Bakery cafes</span>
                    <span>Breakfast spots</span>
                    </div>
                  </div>
                  <div className="card_content_businelig" data-aos="fade-left">
                    <h5 className="fw-bold">Other Qualifying Businesses</h5>
                    <p className="pcard_con">
                      Various service establishments where employees customarily
                      receive tips from customers.
                    </p>
                    <h6>Examples:</h6>
                    <div className="flex flex-wrap">
                    <span>Cruise ships</span>
                    <span>Casino restaurants</span>
                    <span>Valet services</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h1>Key Eligibility Requirements</h1>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="cardkeyresponsibility">
                <img src={check_icon_card} className="img-fluid" alt="" />
                <p>
                  Your business must have employees who receive tips from
                  customers
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="cardkeyresponsibility">
                <img src={check_icon_card} className="img-fluid" alt="" />
                <p>
                  You must pay FICA taxes (Social Security and Medicare) on
                  those reported tips
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="cardkeyresponsibility">
                <img src={check_icon_card} className="img-fluid" alt="" />
                <p>
                  Your employees must report their tip income to you as the
                  employer
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="cardkeyresponsibility">
                <img src={check_icon_card} className="img-fluid" alt="" />
                <p>
                  The business must have filed the appropriate tax forms (Forms
                  941, 8027, etc.)
                </p>
              </div>
            </div>
            <button
              className="eligibility_card"
              style={{ cursor: "pointer" }}
             onClick={() => setShowModal(true)}

            >
              Check Your Eligibility
            </button>
          </div>
        </div>
      </section>
      <section className="how_it_works" id="howitworks">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="content_works">
                <h1 data-aos="fade-up">How it works</h1>
                <p className="mb-4" data-aos="fade-down">
                  Our streamlined process makes claiming your FICA tip credit
                  simple & hassle-free
                </p>
                <div className="d-flex mb-3 gap-4 text_how_work">
                  <div>
                    <h3 class="number">01.</h3>
                  </div>
                  <div className="textwork">
                    <h3>Simple Application</h3>
                    <p>
                      Fill out our quick form with basic information about your
                      business
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 gap-4 text_how_work">
                  <div>
                    <h3 class="number">02.</h3>
                  </div>
                  <div className="textwork">
                    <h3>Our CPAs Process Your Claim</h3>
                    <p>
                      Our tax specialists handle all paperwork and IRS
                      requirements
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3  gap-4 text_how_work">
                  <div>
                    <h3 class="number">03.</h3>
                  </div>
                  <div className="textwork">
                    <h3>Receive Approval</h3>
                    <p>
                      We work with the IRS to get your claim approved quickly
                    </p>
                  </div>
                </div>
                <div className="d-flex mb-3 gap-4 text_how_work">
                  <div>
                    <h3 class="number">04.</h3>
                  </div>
                  <div className="textwork">
                    <h3>Get Funded in Weeks</h3>
                    <p>Receive your credit in weeks, not months</p>
                  </div>
                </div>
                 <button
              className="eligibility_card "
              style={{ cursor: "pointer" }}
             onClick={() => setShowModal(true)}

            >
              Check Your Eligibility
            </button>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="how_it_work_image text-right" data-aos="fade-left">
                <img
                  src={how_it_work_img}
                  className="img-fluid hoe_itWork_img"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="why_choose_credit" id="benefits">
        <div className="container">
          <div className="row">
            <div className="content_why_choose">
              <h1>Why Choose Tiptax to Help Recover Your FICA Tip Credits</h1>
              <p>
                We specialize exclusively in maximizing FICA tip credits for the
                hospitality industry
              </p>
              <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="choose_card">
                    <img src={expertise_icon} className="img-fluid" alt="" />
                    <h4>Expertise</h4>
                    <p>
                      Our partner have processed over $1 billion in FICA
                      tip credits, ERTC Funds, & Visa / Mastercard Settlements.
                      We handle everything from start to finish
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="choose_card">
                    <img src={speed_icon} className="img-fluid" alt="" />
                    <h4>Speed</h4>
                    <p>
                      While others take months, we get you funded within weeks
                      through our streamlined process
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="choose_card">
                    <img src={return_maxi} className="img-fluid" alt="" />
                    <h4>Maximized Returns</h4>
                    <p>
                      Our proprietary methods ensure you get every dollar you
                      deserve, often 30% more than DIY approaches
                    </p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="choose_card">
                    <img src={zero_upfront} className="img-fluid" alt="" />
                    <h4>Zero Upfront Costs</h4>
                    <p>
                      You pay only when you receive your credit—no risk, no
                      hidden fees
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="counter">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="card_counter" data-aos="fade-left">
                <img src={counter_img1} className="img-fluid" alt="" />
                <p>Claims Processed By Our Partners</p>
                <h2>$1B+</h2>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="card_counter" data-aos="fade-up">
                <img src={counter_img2} className="img-fluid" alt="" />
                <p>Businesses Helped</p>
                <h2>1000+</h2>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="card_counter" data-aos="fade-down">
                <img src={counter_img3} className="img-fluid" alt="" />
                <p>Compliance Rate</p>
                <h2>100%</h2>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="card_counter" data-aos="fade-right" style={{ borderRight: "None" }}>
                <img src={counter_img4} className="img-fluid" alt="" />
                <p>States Covered</p>
                <h2>50</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="faqs" id="faqs">
        <div class="container">
          <div class="faqq">
            <div class="row justify-content-center">
              <h1 class="text-center">Frequently Asked Questions</h1>
              <p>Everything you need to know about the FICA Tip Credit</p>
              <div class="col-lg-12">
                <div
                  class="accordion accordion-flush"
                  id="accordionFlushExample"
                >
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOn"
                        aria-expanded="true"
                        aria-controls="flush-collapseOn"
                      >
                        What is the FICA Tip Credit?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseOn"
                      class="accordion-collapse collapse show"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        The FICA Tip Credit (IRS Code Section 45B) is a
                        dollar-for-dollar tax credit that reimburses employers
                        for the FICA taxes (Social Security and Medicare) paid
                        on employee tips above the federal minimum wage. This is
                        not a deduction—it directly reduces your tax liability,
                        providing immediate cash flow benefits to your business.
                      </div>
                    </div>
                  </div>
                  {/* <!-- Q1 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                       How much can my business claim?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseOne"
                      class="accordion-collapse collapse "
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        The credit equals 7.65% of tips reported by your
                        employees that exceed the federal minimum wage. For a
                        restaurant with 20 servers averaging $200 in weekly
                        tips, this can mean over $20,000 per year in tax
                        credits. We can also claim retroactively for up to 3
                        years, potentially resulting in a substantial refund.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Q2 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        Is my business eligible?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        If you own a restaurant, bar, hotel, or any hospitality
                        business where employees receive tips, you're likely
                        eligible. The business must have employees who receive
                        tips that are reported to the IRS, and you must pay FICA
                        taxes on those tips. There is no minimum size
                        requirement—businesses with just a few tipped employees
                        can qualify.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Q3 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseThree"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        How is the credit calculated?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseThree"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        The credit is calculated as 7.65% (the combined FICA tax
                        rate) of the tip income that exceeds the federal minimum
                        wage. The formula is: (Total reported tips - (Federal
                        minimum wage × Total hours worked)) × 7.65%. Our team
                        handles all these calculations to ensure maximum
                        accuracy and benefit.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Q4 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFour"
                        aria-expanded="false"
                        aria-controls="flush-collapseFour"
                      >
                        Can I claim the credit for past years?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFour"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        Yes, you can claim the FICA tip credit retroactively by
                        filing amended returns for up to 3 years. This means if
                        you've never claimed this credit before, you could
                        receive a substantial refund for prior tax years. Our
                        team specializes in maximizing these retroactive claims.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Q5 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFive"
                        aria-expanded="false"
                        aria-controls="flush-collapseFive"
                      >
                        Does claiming this credit trigger an audit?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFive"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        When properly documented, claiming the FICA tip credit
                        does not increase your audit risk. Our process ensures
                        all claims are thoroughly documented and compliant with
                        IRS requirements. We maintain a 100% compliance rate and
                        stand behind every claim we process.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Q6 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseSix"
                        aria-expanded="false"
                        aria-controls="flush-collapseSix"
                      >
                        How long does the process take?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseSix"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        While most firms take months, our streamlined process
                        typically gets you funded within weeks. After you
                        provide the necessary information, our team handles
                        everything, and you can expect to receive your credit in
                        4-8 weeks in most cases. For retroactive claims, the
                        timeline may be slightly longer.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Q7 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseSeven"
                        aria-expanded="false"
                        aria-controls="flush-collapseSeven"
                      >
                        What documentation do I need?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseSeven"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        We need your business tax returns (Form 1120, 1120S, or
                        1065), payroll reports showing tip income (Form 941),
                        Form 8027 (Employer's Annual Information Return of Tip
                        Income), and Form 8846 if you've previously filed for
                        the credit. Don't worry if you don't have everything—our
                        team will guide you through exactly what's needed.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Q8 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseEight"
                        aria-expanded="false"
                        aria-controls="flush-collapseEight"
                      >
                        Is there a fee for your service?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseEight"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        We work on a contingency basis—you pay nothing upfront.
                        Our fee is a percentage of the credit we secure for you,
                        so we only get paid when you get your money. If we don't
                        get you a credit, you pay nothing. This risk-free
                        approach aligns our success with yours.
                      </div>
                    </div>
                  </div>

                  {/* <!-- Q9 --> */}
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseNine"
                        aria-expanded="false"
                        aria-controls="flush-collapseNine"
                      >
                        How does this credit affect other tax incentives?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseNine"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        The FICA tip credit can be claimed alongside other tax
                        incentives like the Work Opportunity Tax Credit (WOTC)
                        and Employee Retention Credit (ERC). However, you cannot
                        claim FICA tip credit on the same wages used for other
                        wage-based credits. Our tax specialists will optimize
                        your overall tax strategy to maximize all available
                        credits.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseten"
                        aria-expanded="false"
                        aria-controls="flush-collapseten"
                      >
                        Do I need to reduce my wage deduction?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseten"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        Yes, when claiming the FICA tip credit, you must reduce
                        your wage deduction by the amount of the credit claimed.
                        However, this is still highly advantageous as a
                        dollar-for-dollar tax credit provides more benefit than
                        a deduction. Our analysis will show you the net benefit
                        specific to your tax situation.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseelleven"
                        aria-expanded="false"
                        aria-controls="flush-collapseelleven"
                      >
                        What if my employees don't report all their tips?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseelleven"
                      class="accordion-collapse collapse"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        The FICA tip credit is based on reported tips only. We
                        can help implement tip reporting best practices to
                        ensure you're maximizing your credit while maintaining
                        compliance. Improving tip reporting benefits both your
                        business (through increased tax credits) and your
                        employees (through increased Social Security benefits).
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center flex-column align-items-center pb-5">
            <p class="text-center">
              Have more questions about the FICA Tip Credit? Our tax specialists
              are here to help you understand how much you could save.
            </p>
            <button
              class="faq_button"
              style={{ cursor: "pointer" }}
             onClick={() => setShowModal(true)}

            >
              Get Started Today!
            </button>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <div className="container">
          <h1 data-aos="fade-up">What Our Clients Says</h1>
          <p className="test_p" data-aos="fade-down">
            Join thousands of satisfied restaurant and bar owners who've
            recovered significant tax credits
          </p>
          <div className="row mt-5">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="testimonials_content" data-aos="fade-left">
                <img
                  src={testimonialiconcomma}
                  className="img-fluid mb-3"
                  alt=""
                />
                <div className="d-flex gap-2 mb-3">
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                </div>
                <p className="texttest">
                  "We recovered over $45,000 in tax credits we didn't even know
                  we were eligible for. The process was incredibly simple on our
                  end."
                </p>
                <div className="infotestimonoal">
                  <h5>Michael R.</h5>
                  <p>Owner, Fine Dining Restaurant Group</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="testimonials_content" data-aos="fade-up">
                <img
                  src={testimonialiconcomma}
                  className="img-fluid mb-3"
                  alt=""
                />
                <div className="d-flex gap-2 mb-3">
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                </div>
                <p className="texttest">
                  "As a small bar owner, I was skeptical, but Tip Credit
                  Partners delivered exactly what they promised. $18,500 back in
                  my pocket with zero hassle."
                </p>
                <div className="infotestimonoal">
                  <h5>Sarah T.</h5>
                  <p>Owner, Neighborhood Bar</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="testimonials_content"data-aos="fade-right">
                <img
                  src={testimonialiconcomma}
                  className="img-fluid mb-3"
                  alt=""
                />
                <div className="d-flex gap-2 mb-3">
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                  <img src={starIcon} className="img-fluid" alt="" />
                </div>
                <p className="texttest">
                  "The team was professional, thorough, and communicated every
                  step of the way. We received $67,000 in credits we didn't know
                  existed."
                </p>
                <div className="infotestimonoal">
                  <h5>David L.</h5>
                  <p>CFO, Regional Restaurant Chain</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default index;
